import { MS_PER_HOUR } from "./time";

const toNumber = (value) => {
  if (value === "" || value === null || value === undefined) return null;
  const num = Number(value);
  return Number.isFinite(num) ? num : null;
};

const computeSchedule = (projectStartAt, events) => {
  if (!projectStartAt) {
    return events.map((event) => ({ ...event, startAt: null, endAt: null }));
  }
  let cursor = new Date(projectStartAt);
  if (Number.isNaN(cursor.getTime())) {
    return events.map((event) => ({ ...event, startAt: null, endAt: null }));
  }

  return events.map((event) => {
    const estimated = toNumber(event.estimatedHours) ?? 0;
    const actual = toNumber(event.actualHours);
    const duration = actual ?? estimated;
    const start = new Date(cursor);
    const end = new Date(cursor.getTime() + duration * MS_PER_HOUR);
    cursor = end;

    return {
      ...event,
      startAt: start.toISOString(),
      endAt: end.toISOString(),
    };
  });
};

const calculateTotals = (events) => {
  const estimatedHours = events.reduce(
    (sum, event) => sum + (toNumber(event.estimatedHours) ?? 0),
    0
  );
  const actualHours = events.reduce(
    (sum, event) => sum + (toNumber(event.actualHours) ?? 0),
    0
  );
  return {
    estimatedDays: (estimatedHours / 24).toFixed(2),
    actualDays: (actualHours / 24).toFixed(2),
  };
};

const calculateCumulativeSeries = (events) => {
  let cumulativeEstimated = 0;
  let cumulativeActual = 0;

  return events.map((event) => {
    const estimated = toNumber(event.estimatedHours) ?? 0;
    const actual = toNumber(event.actualHours);
    cumulativeEstimated += estimated;
    if (actual !== null) {
      cumulativeActual += actual;
    }

    return {
      label: event.operation,
      cumulativeEstimated,
      cumulativeActual: actual !== null ? cumulativeActual : null,
    };
  });
};

export {
  toNumber,
  computeSchedule,
  calculateTotals,
  calculateCumulativeSeries,
};
